/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Desktop_Step_2Inputs */

const en_mk_desktop_step_2 = /** @type {(inputs: Mk_Desktop_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to your chosen agent`)
};

const id_mk_desktop_step_2 = /** @type {(inputs: Mk_Desktop_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login ke agent pilihanmu`)
};

/**
* | output |
* | --- |
* | "Sign in to your chosen agent" |
*
* @param {Mk_Desktop_Step_2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_desktop_step_2 = /** @type {((inputs?: Mk_Desktop_Step_2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Desktop_Step_2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_desktop_step_2(inputs)
	return en_mk_desktop_step_2(inputs)
});